import Vue from "vue";
import IO from "socket.io-client";
import cache from "../assets/lib/cache";
import basic from "../model/zone";
import $store from "@/store";
class Event {
  constructor(vue) {
    this.name = "Event";
  }

  connect() {
    if (!Vue._hub.socket) {
      let user = cache.getSession("dtit_user");
      Vue._hub.socket = IO(Vue._config.api.socket, {
        query: `access_token=${user && user.access_token}`,
        transports: ["websocket"],
      });
      // 进行事件处理
      Vue._hub.socket.on("connect", () => {
        Vue._logger.debugger("connect");
        this.bindEvent();
      });
      Vue._hub.socket.on("disconnect", () => {
        Vue._logger.debugger("disconnect");
      });
    }
  }

  bindEvent() {
    Vue._hub.devices &&
      Vue._hub.devices.forEach((d) => {
        Vue._hub.socket &&
          Vue._hub.socket.emit("register", {
            deviceId: d.coreid,
            eventName: "xlc-status-translate",
          });
        Vue._hub.socket &&
          Vue._hub.socket.emit("register", {
            deviceId: d.coreid,
            eventName: "xlc-data-sensor",
          });
        Vue._hub.socket &&
          Vue._hub.socket.emit("register", {
            deviceId: d.coreid,
            eventName: "spark/status",
          });
      });
    Vue._hub.socket.on("xlc-status-translate", (data) => {
      this.updateDevice(data);
    });
    Vue._hub.socket.on("xlc-data-sensor", (data) => {
      this.updateSensor(data);
    });
    Vue._hub.socket.on("spark/status", (data) => {
      this.updateController(data);
    });
    // Vue._hub.socket.on('xlc-data-modbus', data => {
    //   this.updateDevice(data)
    //   //  $store.commit('SET_DL', data)
    // })
  }

  updateDevice(data) {
    if (data && data.data) {
      let payload = { coreid: data.coreid, nd: data.data.nd, type: data.data.type };
      const status = data.data;
      if (status.type === "light") {
        let state = {};
        if (status.hasOwnProperty("State")) {
          state.state = status.State;
        }
        if (status.hasOwnProperty("BR")) {
          state.brightness = status.BR;
        }
        if (status.hasOwnProperty("CCT")) {
          state.cct = status.CCT;
        }
        if (status.hasOwnProperty("filter")) {
          state.filter = status.filter;
        }
        Object.assign(payload, {
          data: state,
        });
        $store.commit("UPDATE_LIGHT", payload);
      } else if (status.type === "remote") {
        // 控制面板
        if (status.hasOwnProperty("km")) {
          // 64 nd
          let findObj = $store.state.remotes.find((f) => f.nd === 64);
          if (findObj) {
            findObj.km = status.km;
            $store.commit("SET_REMOTES", $store.state.remotes);
          }
        }
      } else {
        Object.assign(payload, { data: basic.extDeviceStateMapping(data.data.type, data.data) });
        $store.commit("UPDATE_EXT", payload);
      }
    } else {
      console.error("params error", data);
    }
  }

  updateSensor(data) {
    try {
      let sensor = JSON.parse(data.data);
      if ($store.state.sensorNd.length) {
        $store.state.sensorNd.forEach((item) => {
          if (item.deviceId === data.coreid && item.nds.includes(sensor.nd)) {
            sensor.lastHeard = data.published_at;
            $store.commit("UPDATE_SENSOR", sensor);
          }
        });
      } else if (sensor.nd === 130) {
        sensor.lastHeard = data.published_at;
        $store.commit("UPDATE_SENSOR", sensor);
      }
    } catch (e) {
      console.log(e);
    }
  }

  updateController(data) {
    // 找到对应的控制器，对其进行设备上下线的处理
    $store.commit("UPDATE_DEVICE", {
      coreid: data.coreid,
      connected: (data.data === "online" && true) || false,
    });
  }

  disconnect() {
    Vue._hub.socket && Vue._hub.socket.close();
    Vue._hub.socket = null;
  }
}

export default new Event();
